import { Group, Icon, Stack, Text, Title } from "@assetwatch/ui";
import { Card as ExperimentalCard } from "@assetwatch/ui/experimental";
import { useTranslation } from "react-i18next";
import type { EnterpriseAssetsV2SummaryResponse } from "../api/enterpriseClient";
import { AssetsV2HighRiskBar } from "./snowflakes/AssetsV2HighRiskBar";

export function AssetsV2RiskDistribution({
  summary,
}: {
  summary: EnterpriseAssetsV2SummaryResponse["summary"];
}) {
  const { t } = useTranslation();

  return (
    <ExperimentalCard padding="md" className="bg-surface-container-low">
      <Stack gap={16}>
        <Group align="start" gap={16} wrap="nowrap">
          <span className="mt-(--spacing-4) text-datavis-crit-yellow">
            <Icon name="triangle-exclamation-solid" size="xl" tone="inherit" />
          </span>
          <Stack gap={8}>
            <div className="uppercase">
              <Title as="h2" size="lg">
                {t("enterprise.assetsV2.riskTitle")}
              </Title>
            </div>
            <Text tone="subtle">
              {t("enterprise.assetsV2.riskDescription")}
            </Text>
          </Stack>
        </Group>
        <AssetsV2HighRiskBar summary={summary} />
      </Stack>
    </ExperimentalCard>
  );
}
